// jshint esversion: 6
//faqapp.js - v1.2.5 (servisson-faq)
// cache-bust 2

if (!String.prototype.trim) {
    String.prototype.trim = function() {
        return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    };
}
if (typeof faqApp === "undefined") {
    var faqApp = {
        func: {},
        vars: {},
        cmb: {},
        lc: {},
        oneTrust: {},
        obj: {}
    };
}
faqApp.vars.onSearchPage = false;
faqApp.vars.brand = '';
faqApp.vars.language = '';
faqApp.vars.validation = '';
faqApp.vars.init = 0;
faqApp.vars.host = 'https://cslobby-api.servisson.com'; //Replaced by grunt-replace <api_host_url>
faqApp.vars.lastfaq = 0;
faqApp.vars.lastcat = 0;
faqApp.vars.active = "faq_nav_topten";
faqApp.vars.gtm = true;
faqApp.vars.mobile = false;
faqApp.vars.device = "desktop";
faqApp.vars.secondLevelDomain = "";
faqApp.vars.gdpr_data = 1;
faqApp.vars.window_size = 0;
faqApp.cmb.on = 1; // default on
faqApp.cmb.permit = false;
faqApp.lc.permit = false;
faqApp.oneTrust.permit = false;
faqApp.obj.events = {};
faqApp.obj.uri = {};
faqApp.obj.translation = {};
faqApp.obj[404] = {
    en: "This page is having a problem loading. Please try again.",
    sv: "Problem med att läsa in den här sidan. Vänligen försök igen.",
    nb: "Det er problemer med å laste inn denne siden. Vennligst prøv igjen.",
    fi: "Tämän sivun lataamisessa on ongelma. Yritä uudestaan.",
    cs: "Tato stránka má problémy s načtením. Prosíme, zkuste znovu.",
    de: "Beim Laden dieser Seite ist ein Problem aufgetreten. Bitte versuche es erneut.",
    nl: "Deze pagina heeft een probleem met laden, probeer het alstublieft opnieuw.",
    pl: "Wystąpiły problemy podczas ładowania tej strony. Prosimy o ponowną próbę.",
    lv: "Šai lapai ir ielādes problēma. Lūdzu mēģiniet vēlreiz.",
    it: "Problema di caricamento della pagina. Riprova.",
    pt: "Esta página apresenta um problema ao carregar. Por favor tente novamente",
    es: "Esta página tiene problemas para cargarse, por favor intente nuevamente.",
    pe: "Esta página tiene problemas para cargarse, por favor intente nuevamente.",
    'pt-br': "Esta página está com problemas para carregar. Por favor, tente novamente.",
    fr: "Erreur durant le chargement de cette page. Veuillez réessayer.",
    et: "Selle lehe laadimisega on probleeme. Proovige uuesti.",
    ru: "На этой странице возникла ошибка при загрузке. Повторите попытку.",
    cl: "Esta página tiene problemas para cargarse, por favor intente nuevamente.",
    ca: "This page is having a problem loading. Please try again.",
    dk: "This page is having a problem loading. Please try again.",
    nz: "This page is having a problem loading. Please try again.",
    in: "This page is having a problem loading. Please try again.",
    jp: "このページの読み込みに問題があります。 もう一度お試しください。",
    gr: "This page is having a problem loading. Please try again.",
    hr: "This page is having a problem loading. Please try again.",
    co: "This page is having a problem loading. Please try again.",
    is: "This page is having a problem loading. Please try again.",
    eu: "This page is having a problem loading. Please try again.",
    sr: "This page is having a problem loading. Please try again.",
    kk: "This page is having a problem loading. Please try again.",
    lt: "This page is having a problem loading. Please try again.",
};
faqApp.obj[503] = {
    en: "Something went wrong. Please try again.",
    eu: "Something went wrong. Please try again.",
    fi: "Jokin meni pieleen. Yritä uudestaan.",
    nb: "Det er problemer med å laste inn denne siden. Vennligst prøv igjen.",
    nz: "This page is having a problem loading. Please try again.",
    pl: "Wystąpił błąd. Prosimy o ponowną próbę.",
};
faqApp.obj.uri.templateUrl = {
    brand: {
        "acb": "../assets/template/acb.template",
        "btd": "../assets/template/btd.template",
        "bth": "../assets/template/bth.template",
        "crc": "../assets/template/crc.template",
        "nda": "../assets/template/nda.template",
        "spc": "../assets/template/spc.template",
    },
    saForm: {
        en: "../assets/template/sa-form-en.template",
        eu: "../assets/template/sa-form-eu.template",
        fi: "../assets/template/sa-form-fi.template",
        nb: "../assets/template/sa-form-nb.template",
        nz: "../assets/template/sa-form-nz.template",
        pl: "../assets/template/sa-form-pl.template",
    },
    saResult: {
        en: "../assets/template/sa-result-en.template",
        eu: "../assets/template/sa-result-eu.template",
        fi: "../assets/template/sa-result-fi.template",
        nb: "../assets/template/sa-result-nb.template",
        nz: "../assets/template/sa-result-nz.template",
        pl: "../assets/template/sa-result-pl.template",
    },
    complaintForm: {
        en: "../assets/template/complaint-form/en-complaint.template",
        pl: "../assets/template/complaint-form/pl-complaint.template",
        fi: "../assets/template/complaint-form/fi-complaint.template",
    },
};
faqApp.func.Initialize = function(param) {
    faqApp.vars.brand = param.brand.toLowerCase();
    faqApp.vars.language = param.language.toLowerCase();

    if (param.settings && param.settings.type) {
        if (param.settings.type == 'uri') {
            faqApp.obj.uri.uri = true;
            if (param.settings.faquri) {
                faqApp.obj.uri.faquri = param.settings.faquri;
            }
            if (param.settings.faqurl) {
                faqApp.obj.uri.faqurl = param.settings.faqurl;
            }
            if (param.settings.categoryuri) {
                faqApp.obj.uri.categoryuri = param.settings.categoryuri;
            }
            if (param.settings.categoryurl) {
                faqApp.obj.uri.categoryurl = param.settings.categoryurl;
            }
            if (param.settings.searchuri) {
                faqApp.obj.uri.searchuri = param.settings.searchuri;
            }
            if (param.settings.searchurl) {
                faqApp.obj.uri.searchurl = param.settings.searchurl;
            }
            if (typeof param.settings.gtm !== 'undefined') {
                faqApp.vars.gtm = param.settings.gtm;
            }
            if (typeof param.settings.mobile !== 'undefined') {
                faqApp.vars.mobile = param.settings.mobile;
                if (faqApp.vars.mobile) {
                    faqApp.vars.device = "mobile";
                }
            }

            if (window.location.search) {
                var faq_a_uri = window.location.search.slice(1, (window.location.search.length)).split("&");
                $.each(faq_a_uri, function(k, d) {
                    faq_a_temp_uri = d.split("=");
                    faqApp.obj.uri[faq_a_temp_uri[0]] = faq_a_temp_uri[1];
                });
            }
        }
    }
    $('#template').load(faqApp.obj.uri.templateUrl.brand[faqApp.vars.brand], function(response, status, xhr) {
        if (status !== 'error') {
            progressLoader(10);
            url = '/api.php?bi=' + faqApp.vars.brand + '&action=getCategories&device=' + faqApp.vars.device;
            faqApp.func.ajax(url, null, true, function(data) {
                progressLoader(20);
                faqApp.obj.translation = data.translation;
                faqApp.obj.info = data.info;

                url = '/api.php?bi=' + faqApp.vars.brand + '&action=getChatWindowSize';
                faqApp.func.ajax(url, null, true, function(sizeValues) {
                    data.info.livechat_window = sizeValues[0];
                    faqApp.func.pageRender(data.categories, data.topten, data.info);
                });

                // callmeback button textarea
                $('#faq_callmeback').html('<span>' + faqApp.obj.translation.callmeback_lbl + '</span><i class="fa fa-phone"></i>');

                // get second-level domain
                var domain = location.hostname.split('.');
                if(domain.length == 3)
                {
                    faqApp.vars.secondLevelDomain = `${domain[1]}.${domain[2]}`;
                }
                else if(domain.length == 4)
                {
                    faqApp.vars.secondLevelDomain = `${domain[1]}.${domain[2]}.${domain[3]}`;
                }
                else if(domain.length == 5)
                {
                    faqApp.vars.secondLevelDomain = `${domain[1]}.${domain[2]}.${domain[3]}.${domain[4]}`;
                }
                else{
                    console.log("Too many levels in domain");
                }
                // update link to cookie gdpr_settings
                $('#cookie_settings_link').attr("href", data.info.url_cookiesettings);

                // get gdpr switch
                faqApp.func.ajax(`/api.php?action=getGDPRswitch&bi=${faqApp.vars.brand}`, null, false, function(gdpr_data) {
                    // render cookie policy text
                    faqApp.vars.gdpr_data = gdpr_data[0].gdpr_active;
                    if (gdpr_data[0].gdpr_active == 1) {
                        // console.log(`active [${gdpr_data[0].gdpr_active}]`);
                        if (faqApp.func.getCookie('CONSENT')) {
                            // console.log("cookie found");
                            var cookie_consent = JSON.parse(decodeURIComponent(faqApp.func.getCookie('CONSENT')));
                        } else { // if no cookie_consent is found
                            // attach link to cookie policy page
                            faqApp.obj.translation.gdpr_text = faqApp.obj.translation.gdpr_text.replace(/(\[gdpr_policy\])/g, `<a href="${data.info.url_privacyinfo}" target="_blank"> ${faqApp.obj.translation.gdpr_policy}</a>`);
                            // attach link to cookie settings page
                            faqApp.obj.translation.gdpr_text = faqApp.obj.translation.gdpr_text.replace(/(\[gdpr_settings\])/g, `<a href="${data.info.url_cookiesettings}" onclick="faqApp.func.cookiesAcknowledged(0);"> ${faqApp.obj.translation.gdpr_settings}</a>`);
                            // apply cookie text according to device
                            if (window.outerWidth >= 768) {
                                $('#cookie-policy').html('<div class="col-sm-9 col-md-10 col-lg-10 notice-text"> <span>' + faqApp.obj.translation.gdpr_text + '</span></div><div class="cookie-btns"><button type="button" id="cookie-yes" class="btn btn-default" onclick="faqApp.func.cookiesAcknowledged(1);">' + faqApp.obj.translation.accept + '</button></div>');
                            } else {
                                $('#cookie-policy').html('<div class="notice-text"> <span>' + faqApp.obj.translation.gdpr_text + '</span></div><div class="cookie-btns"><button type="button" id="cookie-yes" class="btn btn-default" onclick="faqApp.func.cookiesAcknowledged(1);">' + faqApp.obj.translation.accept + '</button></div>');
                            }
                            // if activity_bar (live chat / e-mail / request callback) is at the bottom of screen
                            // since activity_bar may be independent of device
                            if ($('.activity_bar').offset().top > (window.outerHeight / 2)) { // if activity_bar on bottom
                                $('#cookie-policy').css({
                                    'display': 'block',
                                    'margin-bottom': $('.activity_bar').outerHeight()
                                });
                                $('#cookie-btns').addClass("btn-block");
                                $('#faq_totop').css('top', $('#faq_totop').position().top - $('#cookie-policy').outerHeight());
                                $('#faq_callmeback').css('top', $('#faq_callmeback').position().top - $('#cookie-policy').outerHeight());
                            } else { // if activity_bar on top
                                // push floating buttons upwards temporarily
                                $('#cookie-policy').css('display', 'block');
                                $('#faq_totop').css('top', $('#faq_totop').position().top - $('#cookie-policy').outerHeight());
                                $('#faq_callmeback').css('top', $('#faq_callmeback').position().top - $('#cookie-policy').outerHeight());
                            }
                        }
                    }
                });
            });

            if (param.category) {
                faqApp.func.faqsPerCategory(param.category);
            }
        } else {
            if ($('#ajaxProgressBar')) {
                $('#ajaxProgressBar').removeClass('progress-bar-info').addClass('progress-bar-danger');
                $('#progress--header').html('<i class="fa fa-exclamation-triangle"></i> ' + faqApp.obj[404][faqApp.vars.language]);
            }
        }

        var waitForEl = function(selector, callback) {
            if (jQuery(selector).length) {
                callback();
            } else {
                setTimeout(function() {
                    waitForEl(selector, callback);
                }, 100);
            }
        };
    });

    if ($('#faq_totop')) {
        faqApp.func.totop();
    }
    searchRequestLock = false;

    faqApp.oneTrust.permit = true;
};


faqApp.func.faqUri = function(id) {
    var faq_v_href = "";
    if (faqApp.obj.uri.uri && faqApp.obj.uri.faquri) {
        if (faqApp.obj.uri.faqurl) {
            faq_v_href = 'href="' + faqApp.obj.uri.faqurl + '?' + faqApp.obj.uri.faquri + '=' + id + '" ';
        } else {
            faq_v_href = 'href="?' + faqApp.obj.uri.faquri + '=' + id + '" ';
        }

    }
    return faq_v_href;
};
faqApp.func.categoryUri = function(id) {
    var faq_v_href = "";
    if (faqApp.obj.uri.uri === true && faqApp.obj.uri.categoryuri) {
        if (faqApp.obj.uri.categoryurl) {
            faq_v_href = 'href="' + faqApp.obj.uri.categoryurl + '?' + faqApp.obj.uri.categoryuri + '=' + id + '" ';
        } else {
            faq_v_href = 'href="?' + faqApp.obj.uri.categoryuri + '=' + id + '" ';
        }

    }
    return faq_v_href;
};
faqApp.func.searchUri = function(data) {
    var faq_v_href = "";
    if (faqApp.obj.uri.uri === true && faqApp.obj.uri.searchuri) {
        if (faqApp.obj.uri.searchurl) {
            faq_v_href = faqApp.obj.uri.searchurl + '?' + faqApp.obj.uri.searchuri + '=' + encodeURI(data);
        } else {
            faq_v_href = '?' + faqApp.obj.uri.searchuri + '=' + encodeURI(data);
        }

    }
    return faq_v_href;
};
faqApp.func.ajax = function(action, sendData, loadingSwitch, callback) {
    $.ajax({
        type: "POST",
        timeout: 10000,
        url: faqApp.vars.host + action + "&lang=" + faqApp.vars.language,
        data: sendData,
        global: loadingSwitch,
        success: function(response) {
            if (response) {
                var data;
                if (typeof response !== "object") {
                    data = JSON.parse(response);
                } else {
                    data = response;
                }
                if (data.length < 1) {
                    faqApp.vars.lastfaq = 0;
                    faqApp.vars.lastcat = 0;
                    $('#faq_app_renderbox').html('<div class="faq_body_alert"><i class="fa fa-exclamation-triangle"></i> ' + faqApp.obj[503][faqApp.vars.language] + '</div>');
                }
                if (callback) callback(data);
            }
        },
        error: function(error, textmessage) {
            if ($('#ajaxProgressBar')) {
                $('#ajaxProgressBar').removeClass('progress-bar-info').addClass('progress-bar-danger');
                $('#progress--header').html('<i class="fa fa-exclamation-triangle"></i> ' + faqApp.obj[404][faqApp.vars.language]);
            } else {
                faqApp.vars.lastfaq = 0;
                faqApp.vars.lastcat = 0;
                $('#faq_app_renderbox').html('<div class="faq_body_alert"><i class="fa fa-exclamation-triangle"></i> ' + faqApp.obj[503][faqApp.vars.language] + '</div>');
            }
        }
    });
};
// when an ajax request is sent, sp-circle will be displayed until a response is received
$('#faq_app_renderbox').ready(function() {
    $(document).ajaxStart(function() {
        faqApp.func.scroll();
        $('#faq_app_renderbox').hide();
        $('#faq_app_renderbox').html('<div class="sp sp-circle"></div>').show();
    }).ajaxStop(function() {
        $('#faq_app_renderbox').show();
        $('.sp-circle').hide();
    });
});

faqApp.func.grabElement = function(d) {
    return document.getElementById(d);
};

faqApp.func.addElement = function(a, b, c, d, e) {
    var element = document.createElement(a);
    var element_id = document.createAttribute('id');
    var element_class = document.createAttribute('class');
    element_id.value = b;
    element_class.value = c;
    element.setAttributeNode(element_id);
    element.setAttributeNode(element_class);
    faqApp.func.grabElement(d).appendChild(element);
    if (e) {
        e();
    }
};
faqApp.func.vote = function(e, recordId) {
    voteValue = faqApp.func.getId(e.id);
    recordTitle = $('.faq--record h2').text();
    faqApp.func.ajax("/ajaxservice.php?action=savevoting", 'type=faq&vote=' + voteValue + '&id=' + recordId + '&lang=' + faqApp.vars.language, false, function(data) {
        if (data.success) {
            faqApp.func.grabElement('faq_footer_id').innerHTML = '<span class="faq--response"><br />' + data.success + '</span>';
        } else {
            faqApp.func.grabElement('faq_footer_id').innerHTML = '<span class="faq--response"><br />' + data.error + '</span>';
        }
    });

    // GAM - vote
    if (voteValue == 5) {
        voteValue = 'Yes';
    } else {
        voteValue = 'No';
    }
    pushDatalayer(3, null, null, recordId, recordTitle, null, null, voteValue);
};
faqApp.func.search = function(e) {
    // make current active category inactive when keyword searched
    $('#' + faqApp.vars.active).removeClass('faq_nav_active').addClass('faq_nav_inactive');
    faqApp.vars.active = null;
    var searchResults = 0;
    if (e.keyCode === 13 || e.type == 'click' || e.faqsearch) {
        if (!searchRequestLock) {
            // faqApp.func.enableSearchRequestLock(); // enable grey background on search box, disables & locks it
            var faqSearchString = faqApp.func.grabElement('faq_textinput_id').value;
            faqSearchString = DOMPurify.sanitize(faqSearchString);
            if (faqSearchString && faqApp.obj.uri.searchuri) {
                window.open(faqApp.func.searchUri(faqSearchString), '_self');
            } else if (e.faqsearch) {
                faqSearchString = e.faqsearch;
            }
            if ((!faqApp.obj.uri.searchuri && !faqApp.obj.uri.searchurl) || e.faqsearch) {
                quotedSearchString = "'" + faqSearchString.trim() + "'";
                url = '/api.php?bi=' + faqApp.vars.brand + '&device=' + faqApp.vars.device + '&action=search&q=';
                faqApp.func.ajax(url + encodeURI(quotedSearchString).slice(0, 100), null, true, function(data) {
                    faqApp.vars.lastfaq = 0;
                    faqApp.vars.lastcat = 0;
                    //render result
                    if (data.length > 0) {
                        found = true;
                        searchResults = data.length;
                        // run render function w/ number of found searchResults as parameter
                        faqApp.func.render(true, data, 1, searchResults, faqSearchString, true);
                        var searchPhrase = faqSearchString.trim().split(" ");
                        faqApp.func.highlightWordsinDom(faqApp.func.grabElement('faq_app_renderbox'), searchPhrase);
                    } else if (data.length === 0) {
                        // run render function w/ 0 found searchResults as parameter
                        faqApp.func.render(true, data, 1, 0, faqSearchString, true);
                        faqApp.func.grabElement('faq_app_renderbox').innerHTML = '<div class="faq--resulttree zero--results">' + faqApp.obj.translation.search_zeroresult + '<p class="zero--results-string">"' + faqSearchString.trim() + '"</p></div>';
                    } else {
                        faqApp.func.grabElement('faq_app_renderbox').innerHTML = '<div class="faq--resulttree zero--results">' + faqApp.obj.translation.search_zeroresult + '<p class="zero--results-string">"' + faqSearchString.trim() + '"</p></div>';
                    }
                    faqApp.func.disableSearchRequestLock();
                    faqApp.func.scroll();
                    searchRequestLock = false;
                });
            } else {
                window.open(faqApp.func.searchUri(faqSearchString), '_self');
            }
        }
    }
};

faqApp.func.enableSearchRequestLock = function() {
    searchRequestLock = true;
    // disable submit and textfield
    $('.faq--searchinput').prop('disabled', true);
    $('.faq--searchbutton').prop('disabled', true);
    // darken background color
    $('.faq--searchinput').css("background-color", "#bbbbbb");
    $('.faq--searchbutton').css("background-color", "#bbbbbb");
    return searchRequestLock;
};
faqApp.func.disableSearchRequestLock = function() {
    searchRequestLock = false;
    $('.faq--searchinput').prop('disabled', false);
    $('.faq--searchbutton').prop('disabled', false);
    $('.faq--searchinput').removeAttr('style');
    $('.faq--searchbutton').removeAttr('style');
    return searchRequestLock;
};

faqApp.func.render = function(render, data, type, searchResults, faqSearchString, searchMade) {
    if ($('#navigation-panel') && $('#navigation-panel').hasClass('mb_panel_show')) {
        faqApp.func.hamburger();
    }
    faqApp.obj.events.history = {
        data: data,
        type: type
    };
    // Cache Bust 1
    if (render) {
        faqApp.func.grabElement('faq_app_renderbox').innerHTML = "";
        $.each(data, function(k, e) {
            if (e.category_name && !faqApp.func.grabElement('faq--cathead-' + e.category_id)) {
                faqApp.func.grabElement('faq_app_renderbox').innerHTML = faqApp.func.grabElement('faq_app_renderbox').innerHTML + '<h1 id="faq--cathead-' + e.category_id + '">' + e.category_name + '<a href="#site" class="faq_home_btn"><i class="fa fa-arrow-circle-o-up fa-sm pull-right"></i></a></h1>';
            }
            faqApp.func.grabElement('faq_app_renderbox').innerHTML = faqApp.func.grabElement('faq_app_renderbox').innerHTML + faqApp.func.resultTree(e, type);
        });
    }
    if ((searchResults != 0) && (!searchMade)) {
        // #76 - Checks whether active category matches actual rendered content title
        categ = 'faq_category_id_' + faqApp.obj.events.history.data[0].category_id;
        if (faqApp.vars.active != categ) {
            faqApp.func.navigation(categ, true);
        }
    }
    faqApp.func.scroll();
    if (faqApp.vars.init === 0) {
        progressLoader(10);
        faqApp.vars.init = 1;
    }
    // GAM - search
    if (searchMade) {
        faqApp.vars.onSearchPage = true;
        pushDatalayer(2, null, "Search Results", null, null, faqSearchString, searchResults, null);
    }
};
faqApp.func.resultTree = function(data, type) {
    var datablock = "";
    switch (type) {
        case 1:
            datablock = '<section class="faq--resulttree"><h2><a role="button" ' + faqApp.func.faqUri(data.id) + '  id="faq_result_id_' + data.id + '" faq-data="ajax-faq">' + data.question + '</a><a href="#site" class="faq_home_btn"><i class="fa fa-arrow-circle-o-up fa-sm pull-right"></i></a></h2><p>' + data.answer + '</p></section>';
            break;
        case 2:
            var answerPreview = data.record_preview.trim() + "..." + (faqApp.obj.translation.read_more_lbl ? ` <a role="button" id="faq_preview_link_id_${data.record_id}">${faqApp.obj.translation.read_more_lbl}</a>` : "");
            datablock = '<section class="faq--resulttree"><h2><a role="button" ' + faqApp.func.faqUri(data.record_id) + '  id="faq_result_id_' + data.record_id + '" faq-data="ajax-faq">' + data.record_title + '</a></h2><p>' + answerPreview + '</p></section>';
            break;
    }
    return datablock;
};

faqApp.func.highlightWordsinDom = function(root, wordArray) {
    for (var i = 0; i < wordArray.length; i++) {
        if (wordArray[i].length > 3) {
            faqApp.func.highlightWordInDom(root, wordArray[i]);
        }
    }
};

faqApp.func.highlightWordInDom = function(root, word) {
    textNodesUnder(root).forEach(highlightWords);

    function textNodesUnder(root) {
        var walk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false),
            text = [],
            node;
        while (node = walk.nextNode()) text.push(node);
        return text;
    }
    //Highlight search function
    function highlightWords(n) {
        word = word.toLowerCase();
        var after;
        for (var i;
            (i = n.nodeValue.toLowerCase().indexOf(word, i)) > -1; n = after) {
            after = n.splitText(i + word.length);
            var highlighted = n.splitText(i);
            var span = document.createElement('span');
            span.className = 'faq--highlight';
            span.appendChild(highlighted);
            after.parentNode.insertBefore(span, after);
        }
    }
};

faqApp.func.getId = function(data) {
    if (data !== parseInt(data, 10)) {
        data = data.replace(/[^\-\d]*(\-?\d*).*/, '$1');
    }
    return data;
};

faqApp.func.openFaq = function(e, quickLinkClicked) {
    if (quickLinkClicked) {
        categoryName = 'Quick Link';
        recordId = $(e).parent().attr('id');
        recordName = e.innerHTML;
    } else {
        categoryName = faqApp.func.getCategoryName();
        recordId = faqApp.func.getId(e.id);
        recordName = e.text;
    }
    if ($('#navigation-panel') && $('#navigation-panel').hasClass('mb_panel_show')) {
        faqApp.func.hamburger();
    }
    if (typeof faqApp.vars.lastfaq === "number" && faqApp.vars.lastfaq != parseInt(recordId)) {
        faqApp.vars.lastfaq = parseInt(recordId);
        faqApp.vars.lastcat = 0;
        if (faqApp.func.grabElement('faq_result_id_' + recordId)) {
            faqApp.func.grabElement('faq_result_id_' + recordId).innerHTML = faqApp.func.grabElement('faq_result_id_' + recordId).innerHTML + '<div class="faq--ajaxspinner"></div>';
        }
        if ((!faqApp.obj.uri.faquri && !faqApp.obj.uri.faqurl) || faqApp.obj.uri[faqApp.obj.uri.faquri]) {
            url = '/api.php?bi=' + faqApp.vars.brand + '&device=' + faqApp.vars.device + '&action=getFaq&recordId=';
            if (quickLinkClicked) {
                categoryUrl = '/api.php?bi=' + faqApp.vars.brand + '&device=' + faqApp.vars.device + '&action=getQuickLinkCategory&recordId=';
                faqApp.func.ajax(categoryUrl + recordId, null, true, function(data) {
                    if (data.length > 0) {
                        faqApp.func.render(false, data, 2);
                    }
                    faqApp.func.loadFaq(url, recordId);
                });
            } else {
                faqApp.func.loadFaq(url, recordId);
            }
        }
    }
    // GAM - record
    pushDatalayer(1, null, categoryName, recordId, recordName, null, null, null);

};

faqApp.func.loadFaq = function(url, recordId) {
    faqApp.func.ajax(url + recordId, null, true, function(data) {
        faqApp.func.grabElement('faq_app_renderbox').innerHTML = faqApp.func.resultFaq(data);

        //Declaration of search words array
        var searchPhrase = faqApp.func.grabElement('faq_textinput_id').value.trim().split(" ");
        searchPhrase = DOMPurify.sanitize(searchPhrase);
        searchPhrase = searchPhrase.split(",");
        if (searchPhrase.length > 0) {
            faqApp.func.highlightWordsinDom(faqApp.func.grabElement('faq_app_renderbox'), searchPhrase);
        }
        faqApp.func.scroll();
        if ($('#launchsaform').length > 0) {
            if (typeof faqApp.func.loadSaForm === 'function') {
                faqApp.func.loadSaForm();
            }
        }
        //Complaint Form
        if ($('#launchcomplaintform').length > 0) {
            if (typeof faqApp.func.loadComplaintForm === 'function') {
                faqApp.func.loadComplaintForm();
            }
        }
    });
};

faqApp.func.keywordSearch = function(e) {
    faqApp.vars.lastfaq = 0;
    faqApp.vars.lastcat = 0;
    var faqSearchString = faqApp.func.grabElement('faq_textinput_id').value;
    faqSearchString = DOMPurify.sanitize(faqSearchString);
    quotedSearchString = "'" + faqSearchString.trim() + "'";
    url = '/api.php?bi=' + faqApp.vars.brand + '&device=' + faqApp.vars.device + '&action=search&q=';
    faqApp.func.ajax(url + quotedSearchString, null, true, function(data) {
        if (data.length > 0)
            faqApp.func.render(true, data, 1);
    });
};
faqApp.func.faqsPerCategory = function(e) {
    if (typeof faqApp.vars.lastcat === "number" && faqApp.vars.lastcat != parseInt(faqApp.func.getId(e))) {
        faqApp.vars.lastcat = parseInt(faqApp.func.getId(e));
        faqApp.vars.lastfaq = 0;
        if ((!faqApp.obj.uri.categoryuri && !faqApp.obj.uri.categoryurl) || faqApp.obj.uri[faqApp.obj.uri.categoryuri]) {
            url = '/api.php?bi=' + faqApp.vars.brand + '&device=' + faqApp.vars.device + '&action=getFaqs&categoryId=';
            faqApp.func.ajax(url + faqApp.func.getId(e), null, true, function(data) {
                if (data.length > 0)
                    faqApp.func.render(true, data, 2);
            });
        }
    }
    // GAM - category
    pushDatalayer(0, faqApp.func.getId(e), faqApp.func.getCategoryName(), null, null, null, null, null);
};

faqApp.func.getCategoryName = function() {
    return $('.faq_nav_active').text();
};

faqApp.func.resultFaq = function(data) {
    var keywordNode = "",
        backbutton = "";
    if (data.keywords.length > 0) {
        var keywords = data.keywords.split(",");
        $.each(keywords, function(k, d) {
            keywordNode = keywordNode + '<a role="button" id="' + d + '" faq-data="ajax-keyword">' + d + '</a>';
        });
        keywordNode = '<div class="faq--keywords" id="faq_keywords_id">Keywords ' + keywordNode + '</div>';
    }
    if (faqApp.obj.events.history && faqApp.obj.events.history.data[0] && faqApp.obj.events.history.data[0].category_name) {
        backbutton = '<h1><a role="button" id="faq_history_id" faq-data="object-history" class="faq--backbtn"><i class="fa fa-chevron-left"></i>' + faqApp.obj.events.history.data[0].category_name + '</a></h1>';
    } else if ($('#faq_textinput_id').val().length > 0) {
        backbutton = '<h1><a role="button" id="faq_history_id" faq-data="object-history" class="faq--backbtn"><i class="fa fa-chevron-left"></i>' + faqApp.obj.translation.back_to_search_button_lbl + ' ' + $('#faq_textinput_id').val() + '</a></h1>';
        faqApp.vars.onSearchPage = true;
    }

    if ((faqApp.vars.active == "faq_nav_topten")) {
        backbutton = '<h1><a role="button" id="faq_nav_topten" faq-data="object-topten" class="faq--backbtn"><i class="fa fa-chevron-left"></i>' + faqApp.obj.translation.topten_faq_lbl + '</a></h1>';
    }
    if (data.active == "yes") {
        ratingBlock = '<span id="faq--rating-header">' + faqApp.obj.translation.rating_ratethis_lbl + '</span><div class="faq--rating" id="faq_rating_id"><div role="button" id="faq_id_vote_5" faq-data="ajax-vote" faq-value="' + data.id + '"><i class="fa fa-check"></i> ' + faqApp.obj.translation.rating_btn_yes_lbl + '</div><div role="button" id="faq_id_vote_1" faq-data="ajax-vote" faq-value="' + data.id + '"><i class="fa fa-times"></i> ' + faqApp.obj.translation.rating_btn_no_lbl + '</div></div>';
    } else {
        ratingBlock = "";
    }
    var datablock = backbutton + '<section class="faq--record"><h2>' + data.title + '</h2>' + data.content + keywordNode + '<div class="faq--footer" id="faq_footer_id">' + ratingBlock + '</div></section>';
    return datablock;
};
faqApp.func.pageRender = function(faq_categories, faq_topten, faq_info) {
    if (!faqApp.func.grabElement('faq_app_renderbox')) {
        // console.log('Application needs an element (e.g DIV) with id="faq_app_renderbox" to function.');
    } else if (!faqApp.func.grabElement('faq_app_searchbox')) {
        // console.log('Application needs an element (e.g DIV) with id"faq_app_searchbox" to function');
    } else {
        if (faq_info) {
            if (faq_info.info_contactinfomsg && faq_info.info_contactinfomsg.length > 2) {
                if($('#contact-info-message')) {
                    const isMobile = window.innerWidth < 1025;
                    if (isMobile) { // Move info message to above contact buttons
                        $('#contact-info-message')[0].parentElement.insertBefore($('#contact-info-message')[0], $('#contact-info-message')[0].parentElement.firstChild);
                    }
                    $('#contact-info-message').html(faq_info.info_contactinfomsg).removeClass('element-hidden');
                }
            }
            if (faq_info.info_alertmsg && faq_info.info_alertmsg.length > 2) {
                if ($('#panel-alert')) {
                    $('#panel-alert').html(faq_info.info_alertmsg).removeClass('element-hidden').addClass('element-show');
                }
            }
            // promo banner
            if (faq_info.info_promotionmsg && faq_info.info_promotionmsg.length > 2) {
                if ($('#panel-promotion')) {
                    $('#panel-promotion').html(faq_info.info_promotionmsg).removeClass('element-hidden').addClass('element-show');
                }
            }
            //
            if (faq_info.info_infomsg && faqApp.func.grabElement('faq--panel')) {
                faqApp.func.addElement('div', 'faq_staticbox', null, 'faq--panel', function(callback) {
                    faqApp.func.grabElement('faq_staticbox').innerHTML = faq_info.info_infomsg;
                });
            }
            if (!faq_info.info_phonenumber) {
                $('#faq_header_chat').removeClass().addClass("col-xs-4 col-sm-4 col-md-4 col-lg-4");
                $('#faq_header_email').removeClass().addClass("col-xs-4 col-sm-4 col-md-4 col-lg-4");
                $('#faq_header_whatsapp').removeClass().addClass("col-xs-4 col-sm-4 col-md-4 col-lg-4");
                $('#faq_header_phone').remove();
            }

            if ((!faq_info.info_phonenumber) && (!faq_info.info_chaturl)) {
                $('#faq_header_email').removeClass().addClass("col-xs-13 col-sm col-md-13 col-lg-13");
                $('#faq_header_phone').remove();
                $('#faq_header_chat').remove();
            }

            // Whatsapp
            if (!faq_info.info_whatsapp) {
                $('#faq_header_chat').removeClass().addClass("col-xs-4 col-sm-4 col-md-4 col-lg-4");
                $('#faq_header_email').removeClass().addClass("col-xs-4 col-sm-4 col-md-4 col-lg-4");
                $('#faq_header_phone').removeClass().addClass("col-xs-4 col-sm-4 col-md-4 col-lg-4");
                $('#faq_header_whatsapp').remove();
            }

            if ((!faq_info.info_phonenumber) && (!faq_info.info_whatsapp)) {
                $('#faq_header_chat').removeClass().addClass("col-xs-6 col-sm col-md-6 col-lg-6");
                $('#faq_header_email').removeClass().addClass("col-xs-6 col-sm col-md-6 col-lg-6");
                $('#faq_header_phone').remove();
                $('#faq_header_whatsapp').remove();
            }

            if (faq_info.info_emailaddress || faq_info.info_phonenumber || faq_info.info_chaturl || faq_info.info_whatsapp) {
                // var printURL = '';
                if (faq_info.info_emailaddress) {
                    // printURL = (faqApp.vars.email_link) ? faqApp.vars.email_link : faq_info.info_emailaddress;
                    let emailTooltipContent = faq_info.info_emailaddress;
                    faqApp.func.addElement('div', 'faq_info_email', 'faq_info_complete', 'faq_header_email', function() {
                        faqApp.func.grabElement('faq_info_email').innerHTML = '<section><a class="btn btn-lg btn-primary btn-block" href="mailto:' + faq_info.info_emailaddress + '" data-toggle="tooltip" data-placement="top" title="' + faq_info.info_emailaddress + '" id="faq_toggle_email"><div class="faq_button_icon"><i class="fa fa-at fa-lg pull-left"></i></div><div class="faq_button_content">' + faqApp.obj.translation.info_email_lbl.replace(/(\[email\])/g,'') + '<p>' + faq_info.info_emailsla + '</p></div></a></section>';
                    });

                    $('[data-toggle="tooltip"]').tooltip();
                }
                if (faq_info.info_phonenumber) {
                    faqApp.func.addElement('div', 'faq_info_phone', 'faq_info_complete', 'faq_header_phone', function() {
                        if (faqApp.cmb.permit) {
                            faqApp.func.grabElement('faq_info_phone').innerHTML = '<section><a class="btn btn-lg btn-link btn-block"><div class="faq_button_icon"><i class="fa fa-phone fa-lg pull-left" alt="' + faqApp.obj.translation.info_phone_lbl + '"></i></div><div class="faq_button_content"><span id="faq_phone_number" >' + faqApp.obj.translation.callmeback_lbl + '</span><div id="faq_phone_call"><span>' + faqApp.obj.translation.callmeback_lbl + '</span></div><p>' + faq_info.info_phonesla + '</p></div></a></section>';
                            document.getElementById('cmb_note').innerHTML = '<span style="display: block;font-size: 12px;font-style: italic;">' + faqApp.obj.translation.cmb_note_message + '</span>';
                        } else {
                            faqApp.func.grabElement('faq_info_phone').innerHTML = '<section><a class="btn btn-lg btn-link btn-block" href="tel:' + faq_info.info_phonenumber + '"><div class="faq_button_icon"><i class="fa fa-phone fa-lg pull-left" alt="' + faqApp.obj.translation.info_phone_lbl + '"></i></div><div class="faq_button_content"><span id="faq_phone_number" >' + faq_info.info_phonenumber + '</span><span id="faq_phone_call" >' + faqApp.obj.translation.info_phone_lbl + '</span><p>' + faq_info.info_phonesla + '</p></div></a></section>';
                        }
                    });
                }
                if (faq_info.info_chaturl) { //new chat form test 3
                    faqApp.func.addElement('div', 'faq_info_chat', 'faq_info_complete', 'faq_header_chat', function() {
                        const chatUrl = faq_info.info_chaturl === "Intercom"
                            ? `Intercom('show');`
                            : `window.open('${faq_info.info_chaturl}', 'ChatWindow', 'height=${faq_info.livechat_window.window_height},width=${faq_info.livechat_window.window_width},resizable=yes,scrollbars=yes');void(0);`;
                        faqApp.func.grabElement('faq_info_chat').innerHTML = `<section><a class="btn btn-lg btn-primary btn-block" href="#" onClick="${chatUrl}"><div class="faq_button_icon"><i class="fa fa-comments-o fa-lg pull-left"></i></div><div class="faq_button_content">${faqApp.obj.translation.info_chat_lbl}<p>${faq_info.info_chatsla}</p></div></a></section>`;
                    })
                }
                if (faq_info.info_whatsapp) {
                    faqApp.func.addElement('div', 'faq_info_whatsapp', 'faq_info_complete', 'faq_header_whatsapp', function() {
                        // Implement if we launch WhatsApp
                    });
                }
            }
            if (faq_info.btn_search_suggestion) {
                $('#faq_subsearch_field').html(faq_info.btn_search_suggestion);
            }
            if (faq_info.info_footerhtml) {
                faqApp.func.grabElement('faq_div_footer').innerHTML = faq_info.info_footerhtml;
            }
            if (faq_info.info_openinghours) {
                faqApp.func.grabElement('faq_howhelp').innerHTML = '<p>' + faq_info.info_openinghours + '</p>';
            }
            // Test push virtual page view event and virtualurl while on main site
            pushDatalayer(6, null, null, null, null, null, null, null);
        }
        if (faqApp.func.grabElement('faq_app_categorybox')) {
            // category header
            faqApp.func.grabElement('faq_app_categorybox').innerHTML = '<h1>' + faqApp.obj.translation.categories_header_lbl + '</h1>';
            //  most_popular_faqs button
            faqApp.func.grabElement('faq_app_categorybox').innerHTML = faqApp.func.grabElement('faq_app_categorybox').innerHTML + '<a role="button" faq-data="object-topten" id="faq_nav_topten" class="faq_nav_active"><li>' + faqApp.obj.translation.topten_faq_lbl + '</li></a>';
            // for each category, render it
            $.each(faq_categories, function(counter, e) {
                if (parseInt(e.parent_id) === 0 && !faqApp.func.grabElement('li' + e.parent_id)) {
                    faqApp.func.grabElement('faq_app_categorybox').innerHTML = faqApp.func.grabElement('faq_app_categorybox').innerHTML + '<a role="button"  ' + faqApp.func.categoryUri(e.id) + ' id="faq_category_id_' + e.id + '" faq-data="ajax-category" class="faq_nav_inactive"><li id="faq_li_id_' + e.id + '" class="faq--toplevel-nosub">' + e.name + '</li></a>';
                } else {
                    if (faqApp.func.grabElement('faq_ul_id_' + e.parent_id)) {
                        faqApp.func.grabElement('faq_ul_id_' + e.parent_id).innerHTML = faqApp.func.grabElement('faq_ul_id_' + e.parent_id).innerHTML + '<a role="button" ' + faqApp.func.categoryUri(e.id) + ' id="faq_category_id_' + e.id + '" faq-data="ajax-category" class="faq_nav_inactive"><li id="faq_li_id_' + e.id + '">' + e.name + '</li></a>';
                    } else {
                        faqApp.func.grabElement('faq_li_id_' + e.parent_id).innerHTML = faqApp.func.grabElement('faq_li_id_' + e.parent_id).innerHTML + '<ul id="faq_ul_id_' + e.parent_id + '" class="ul-hide"><a role="button" ' + faqApp.func.categoryUri(e.id) + ' id="faq_category_id_' + e.id + '" faq-data="ajax-category" class="faq_nav_inactive"><li id="faq_li_id_' + e.id + '" >' + e.name + '</li></a></ul>';
                        faqApp.func.grabElement('faq_li_id_' + e.parent_id).setAttribute("class", "faq--topelevel-category");
                    }
                }
            });

            if(!faqApp.oneTrust.permit)
            {
                faqApp.func.grabElement('faq_app_categorybox').innerHTML = faqApp.func.grabElement('faq_app_categorybox').innerHTML + `<a href="${faq_info.url_cookiesettings}" target="_blank" id="cookie_settings_link" class="faq_nav_inactive" onclick="faqApp.func.cookiesAcknowledged(0);"> <li>${faqApp.obj.translation.gdpr_settings}</li> </a>`;
            }
            if(faqApp.oneTrust.permit)
            {
                faqApp.func.grabElement('faq_app_categorybox').innerHTML = faqApp.func.grabElement('faq_app_categorybox').innerHTML + `<a role="button" id="cookie_settings_link" class="faq_nav_inactive" onclick="OneTrust.ToggleInfoDisplay();"> <li>${faqApp.obj.translation.gdpr_settings}</li> </a>`;
            }

            faqApp.func.grabElement('faq_app_categorybox').innerHTML = '<nav class="faq--navigation"><ul>' + faqApp.func.grabElement('faq_app_categorybox').innerHTML + '</ul></nav>';
        }
        if (faqApp.func.grabElement('faq_app_searchbox')) {
            faqApp.func.grabElement('faq_app_searchbox').innerHTML = '<div class="faq--searchbox"><section class="faq--searchwrapper"><input type="text" class="faq--searchinput" id="faq_textinput_id" placeholder="' + faqApp.obj.translation.search_field_lbl + '" value="" required><button id="faq_searchbtn_id" class="faq--searchbutton"><i class="fa fa-search"></i></button></section></div>';
        }
        if (faqApp.func.grabElement('faq_app_toptenbox') && faq_topten) {
            if (faq_topten.error) {
                faqApp.func.grabElement('faq_app_toptenbox').innerHTML = '<h1>' + faqApp.obj.translation.topten_faq_lbl + '</h1><p>' + faq_topten.error + '</p>';
            } else {
                var list = "";
                $.each(faq_topten.id, function(k, d) {
                    list = list + '<a role="button" ' + faqApp.func.faqUri(d) + ' id="faq_topten_id_' + d + '" faq-data="ajax-faq"><li>' + faq_topten.title[k] + '</li></a>';
                });
                faqApp.vars.topten = '<h1>' + faqApp.obj.translation.topten_faq_lbl + '</h1><ol>' + list + '</ol>';
                faqApp.func.grabElement('faq_app_toptenbox').innerHTML = faqApp.vars.topten;
            }
        }

        if (faqApp.obj.uri[faqApp.obj.uri.faquri]) {
            faqApp.func.openFaq(faqApp.obj.uri[faqApp.obj.uri.faquri]);
        }
        if (faqApp.obj.uri[faqApp.obj.uri.categoryuri]) {
            faqApp.func.faqsPerCategory(faqApp.obj.uri[faqApp.obj.uri.categoryuri]);
        }
        if (faqApp.obj.uri[faqApp.obj.uri.searchuri]) {
            var faq_searchobj = {
                faqsearch: faqApp.obj.uri[faqApp.obj.uri.searchuri]
            };
            faqApp.func.search(faq_searchobj);
            faqApp.func.grabElement('faq_textinput_id').value = decodeURI(faqApp.obj.uri[faqApp.obj.uri.searchuri]);
        }
    }
    if (window.location.search) {
        if (faqApp.obj.uri.category && typeof faqApp.obj.uri.category === 'string' && faqApp.obj.uri.category.length > 3) {
            url = '/api.php?bi=' + faqApp.vars.brand + '&device=' + faqApp.vars.device + '&action=getCategory&categoryName=';
            faqApp.func.ajax(url + faqApp.obj.uri.category.replace(/-/g, '%20'), null, true, function(data) {
                if (data.length > 0)
                    faqApp.func.render(true, data, 2);
            });
        }
        if (faqApp.obj.uri.faq && typeof faqApp.obj.uri.faq === 'string' && faqApp.obj.uri.faq.length > 0) {
            url = '/api.php?bi=' + faqApp.vars.brand + '&device=' + faqApp.vars.device + '&action=getFaq&recordId=';
            faqApp.func.ajax(url + parseInt(faqApp.obj.uri.faq), null, true, function(data) {
                if (data.id) {
                    faqApp.func.grabElement('faq_app_renderbox').innerHTML = faqApp.func.resultFaq(data);
                    if ($('#launchsaform').length > 0) {
                        if (typeof faqApp.func.loadSaForm === 'function') {
                            faqApp.func.loadSaForm();
                        }
                    }
                    if ($('#launchcomplaintform').length > 0) {
                        if (typeof faqApp.func.loadComplaintForm === 'function') {
                            faqApp.func.loadComplaintForm();
                        }
                    }
                }
            });
        }
    }
    $(document).on('click', '#mb_hamburger', function() {
        faqApp.func.hamburger();
    });
    $(document).on('keydown', '#faq_textinput_id', function(e) {
        if (e.keyCode == 13 && e.shiftKey === false) {
            faqApp.func.search(e);
            $('#faq_textinput_id').blur();
        }
    });
    $(document).on('click', '#faq_searchbtn_id', function(e) {
        faqApp.func.search(e);
    });
    $(document).on('click', 'a[faq-data="rg-info"]', function() {
        url = '/api.php?bi=' + faqApp.vars.brand + '&device=' + faqApp.vars.device + '&action=getCategory&categoryName=Responsible%20gaming';
        faqApp.func.ajax(url, null, true, function(data) {
            if (data.length > 0)
                faqApp.func.render(true, data, 2);
            faqApp.vars.lastfaq = 0;
            faqApp.vars.lastcat = 0;
        });
    });
    $(document).on('click', 'a[faq-data="pm-info"]', function() {
        url = '/api.php?bi=' + faqApp.vars.brand + '&device=' + faqApp.vars.device + '&action=getCategory&categoryName=Payment%20methods';
        faqApp.func.ajax(url, null, true, function(data) {
            if (data.length > 0)
                faqApp.func.render(true, data, 2);
            faqApp.vars.lastfaq = 0;
            faqApp.vars.lastcat = 0;
        });
    });
    $(document).on('click', 'a[faq-data="ajax-faq"]', function() {
        if ($(this).parent().attr('id') == undefined) {
            faqApp.func.openFaq(this, false);
        }
    });
    $(document).on('click', 'a[id^="faq_preview_link_id_"]', function() {
        const faqResultLink = document.getElementById("faq_result_id_" + faqApp.func.getId(this.id));
        if (faqResultLink) {
            faqApp.func.openFaq(faqResultLink, false);
        }
    });
    $(document).on('click', '.faq_header_button', function() {
        faqApp.vars.onSearchPage = false;
        faqApp.func.openFaq(this, true);
        faqApp.func.disableSearchRequestLock();
    });
    $(document).on('click', 'a[faq-data="ajax-category"]', function() {
        faqApp.func.navigation(this, false);
        faqApp.func.faqsPerCategory(this.id);
        faqApp.func.disableSearchRequestLock();
    });
    $(document).on('click', 'a[faq-data="ajax-keyword"]', function() {
        faqApp.func.keywordSearch(this.id);
    });
    // vote button
    $(document).on('click', 'div[faq-data="ajax-vote"]', function(e) {
        faqApp.func.vote(this, $(this).attr('faq-value'));
    });

    //Back Button in search function
    $(document).on('click', 'a[faq-data="object-history"]', function() {
        faqApp.vars.lastfaq = 0;
        faqApp.vars.lastcat = 0;
        faqApp.func.render(true, faqApp.obj.events.history.data, faqApp.obj.events.history.type);
        var searchPhrase = faqApp.func.grabElement('faq_textinput_id').value.trim().split(" ");
        faqApp.func.highlightWordsinDom(faqApp.func.grabElement('faq_app_renderbox'), searchPhrase);
    });
    $(document).on('click', 'a[faq-data="object-topten"]', function() {
        faqApp.func.navigation(this, false);
        faqApp.vars.lastfaq = 0;
        faqApp.vars.lastcat = 0;
        $('#faq_app_renderbox').html('<div id="faq_app_toptenbox">' + faqApp.vars.topten + '</div>');
        faqApp.func.scroll();
        if ((this.className == 'faq_nav_inactive faq_nav_active') || ($('#navigation-panel').hasClass('mb_panel_show'))) {
            faqApp.func.hamburger();
        }
        pushDatalayer(0, 0, "Most Popular FAQs", null, null, null, null, null);
        faqApp.func.disableSearchRequestLock();
    });
    $(document).on('click', 'div[faq-data="element-hide"]', function(e) {
        $('#' + $(this).attr('faq-value')).removeClass('element-show').addClass('element-hidden');
    });


    $(document).on('click', '#faq_info_whatsapp', function() {
        // Implement if we launch WhatsApp
    });

    // GAM -Top buttons
    // pushDatalayer(sel, categoryId, categoryName, recordId, recordName, searchKeyword, numberOfRecords, vote);
    $(document).on('click', '#faq_info_chat', function(e) {
        recordName = "livechat";
        pushDatalayer(4, null, null, null, recordName, null, null, null);
    });
    $(document).on('click', '#faq_info_email', function(e) {
        recordName = "email";
        pushDatalayer(4, null, null, null, recordName, null, null, null);
    });
    $(document).on('click', '#faq_info_phone', function(e) {
        recordName = "phone";
        pushDatalayer(4, null, null, null, recordName, null, null, null);
    });

    progressLoader(20);
};
faqApp.func.navigation = function(e, fromRenderfunc) {
    faqApp.vars.onSearchPage = false;
    if (fromRenderfunc == false) {
        e = e.id;
    }
    if (faqApp.vars.active) {
        $('#' + faqApp.vars.active).removeClass('faq_nav_active').addClass('faq_nav_inactive');
        $('#' + e).addClass('faq_nav_active');
        faqApp.vars.active = e;
    } else {
        $('#' + e).addClass('faq_nav_active').addClass('faq_nav_inactive');
        faqApp.vars.active = e;
    }
};
faqApp.func.hamburger = function() {
    if ($('#navigation-panel')) {
        if ($('#navigation-panel').hasClass('mb_panel_show')) {
            $('#navigation-panel').removeClass('mb_panel_show').addClass('mb_panel_slide');
            $('#site').removeClass('mb_site_slide').addClass('mb_site_show');
            $('#ceu_menu').toggleClass("fa-bars");
            $('#ceu_menu').toggleClass("fa-times");

            $('#mb_hamburger.hamburger_reg').css({
                'transform': 'initial'
            });
        } else {
            $('#navigation-panel').removeClass('mb_panel_slide').addClass('mb_panel_show');
            $('#site').removeClass('mb_site_show').addClass('mb_site_slide');
            $('#ceu_menu').toggleClass("fa-bars");
            $('#ceu_menu').toggleClass("fa-times");

            //Rotate hamburger icon if certain class is present
            $('#mb_hamburger.hamburger_reg').css({
                'transform': 'rotate(90deg)'
            });
        }
    }
};
faqApp.func.scroll = function() {
    //scroll to below faq_header_row only if not already at top and more often for mobile devices
    if ($(window).scrollTop() > 50 || $(window).width() < 992) {
        if ($(window).scrollTop() > 256) {
            $(window).scrollTop($('#faq_header_row').height() + 1);
        } else {
            $("html, body").animate({
                scrollTop: ($('#faq_header_row').height() + 1)
            }, "500");
        }
    }
};

// load Self-assessment test and calculate score
faqApp.func.loadSaForm = function() {
    faqApp.vars.sascore = 0;
    $('#faq_app_renderbox').html('<div class="ajaxloader">Loading...</div>');
    $('#faq_app_renderbox').load(faqApp.obj.uri.templateUrl.saForm[faqApp.vars.language], function() {
        faqApp.func.scroll();
        $(document).on('click', '#selfassessment', function() {
            var i = 0;
            var inputCount = $('#selfassessment-form input[type="radio"]').length / 4;
            $.each($('#selfassessment-form input[type="radio"]'), function() {
                if (this.checked === true) {
                    faqApp.vars.sascore += parseInt(this.value);
                    i++;
                }
            });
            if (i === inputCount) {
                $('#faq_app_renderbox').html('<div class="ajaxloader">Loading...</div>');
                $('#faq_app_renderbox').load(faqApp.obj.uri.templateUrl.saResult[faqApp.vars.language], function() {
                    $('#sascore').html(faqApp.vars.sascore);
                    faqApp.func.scroll();
                });
            } else {
                faqApp.vars.sascore = 0;
            }
        });
    });
};

//load Complaint Form and send email
faqApp.func.loadComplaintForm = function() {
    $('#faq_app_renderbox').html('<div class="ajaxloader">Loading...</div>');
    $('#faq_app_renderbox').load(faqApp.obj.uri.templateUrl.complaintForm[faqApp.vars.language], function() {
        faqApp.func.scroll();
        $(document).on('click', '#complaintSubmit', function() {
            $("#complaintForm").validate({
                rules: {
                    fname: "required",
                    email: {
                        required: true,
                        email: true,
                        validEmail: true
                    },
                    dob: "required",
                    incident: "required",
                    uploadedFile: "required",
                    identification: "required",
                    address: "required",
                    shortdesc: "required",
                    phone: "required",
                    amount: "required",
                    request: "required"
                },
                messages: {
                    fname: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    },
                    email: {
                        required: faqApp.obj.translation.cmb_validation_empty,
                        email: faqApp.obj.translation.cmb_validation_email,
                        validEmail: faqApp.obj.translation.cmb_validation_email
                    },
                    incident: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    },
                    uploadedFile: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    },
                    identification: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    },
                    address: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    },
                    shortdesc: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    },
                    dob: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    },
                    phone: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    },
                    amount: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    },
                    request: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    }
                },
                highlight: function(el) {
                    $(el).addClass('invalid-field');
                },
                unhighlight: function(el) {
                    $(el).removeClass('invalid-field');
                },
                submitHandler: function(form) {
                    // removes default submit events and establishes AJAX call
                    event.preventDefault();
                    // show loading bars
                    $("#callmeback_confirmation").css(cmbEnableCSS).html('<div class="sp sp-circle"></div>').show();
                    var form = document.getElementById("complaintForm");
                    var formMessages = $('#callmeback_confirmation');

                    var formData = new FormData();
                    formData.append("comp_id", $('#identification').val());
                    formData.append("comp_name", $('#fname').val());
                    formData.append("comp_address", $('#address').val());
                    formData.append("comp_dob", $('#dob').val());
                    formData.append("comp_email", $('#email').val());
                    formData.append("comp_subject", $('#shortdesc').val());
                    formData.append("comp_message", $('#incident').val());
                    formData.append("comp_phone", $('#phone').val());
                    formData.append("comp_amount", $('#amount').val());
                    formData.append("comp_request", $('#request').val());



                    formData.append("isComplaintForm", $('#isComplaintForm').val());
                    //File Validations and Attaching
                    var filePath = $('#uploadedFile').val();
                    var filesLength = document.getElementById('uploadedFile').files.length;
                    var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;
                    var totalSize = 0;

                    if (!allowedExtensions.exec(filePath)) {
                        if(faqApp.vars.language == 'en'){
                            alert('Please upload .jpeg/.jpg/.png/.pdf files only.');
                        }
                        else if(faqApp.vars.language == 'pl'){
                            alert('Proszę przesyłać wyłącznie pliki w formacie .jpeg/.jpg/.png/.pdf');
                        }
                        else if(faqApp.vars.language == 'fi'){
                            alert('Lähetä vain tiedostoja muodossa .jpeg/.jpg/.png/.pdf');
                        }
                        $('#callmeback_confirmation').hide();
                        $(".sp-circle").hide();
                        throw new Exception();
                    } else {
                        for(var i=0;i<filesLength;i++){
                            formData.append("attachment[]", document.getElementById('uploadedFile').files[i]);
                            totalSize += document.getElementById('uploadedFile').files[i].size;
                        }
                        if(totalSize > 10485760){
                            if(faqApp.vars.language == 'en'){
                                alert('File sizes are too large.');
                            }
                            else if(faqApp.vars.language == 'pl'){
                                alert('Rozmiary plików są zbyt duże.');
                            }
                            else if(faqApp.vars.language == 'fi'){
                                alert('Tiedostojen koko on liian suuri.');
                            }
                            $('#callmeback_confirmation').hide();
                            $(".sp-circle").hide();
                            throw new Exception();
                        }
                    }
                    formData.append("brand", faqApp.vars.brand);
                    formData.append("lang", faqApp.vars.language);

                    for (var pair of formData.entries()) {
                        console.log(pair[0] + ', ' + pair[1]);
                    }

                    $.ajax({
                        type: 'POST',
                        timeout: 15000,
                        url: faqApp.vars.host + '/cmb.php',
                        global: false,
                        data: formData,
                        processData: false, // tell jQuery not to process the data 45
                        contentType: false, // tell jQuery not to set the content type
                        cache: false
                    }).done(function(response) {
                        // clear fields on successful submission
                        $('#complaintForm').trigger('reset');
                        if (faqApp.vars.language == 'en') {
                            $('.background_blanket').css(cmbEnableCSS);
                            // show success submission en
                            $('#callmeback_confirmation').html('<div id="cmb_success"><span class="callback_title">' + "Thanks for your query" + '</span><i id="close_callmeback" class="fa fa-times"></i><br/><br/><p id="cmb_text">' + "Your complaint has been submitted." + '</p></div>');
                            $(".sp-circle").hide();
                        } else if (faqApp.vars.language == 'pl') {
                            $('.background_blanket').css(cmbEnableCSS);
                            // show success submission on pl
                            $('#callmeback_confirmation').html('<div id="cmb_success"><span class="callback_title">' + "Dziękujemy za Twoje zgłoszenie" + '</span><i id="close_callmeback" class="fa fa-times"></i><br/><br/><p id="cmb_text">' + "Twoja skarga została wysłana." + '</p></div>');
                            $(".sp-circle").hide();
                        }else if (faqApp.vars.language == 'fi') {
                            $('.background_blanket').css(cmbEnableCSS);
                            // show success submission on pl
                            $('#callmeback_confirmation').html('<div id="cmb_success"><span class="callback_title">' + "Kiitos ilmoituksestasi" + '</span><i id="close_callmeback" class="fa fa-times"></i><br/><br/><p id="cmb_text">' + "Valituksesi on lähetetty." + '</p></div>');
                            $(".sp-circle").hide();
                        }

                    }).fail(function(data) {
                        $('.background_blanket').css(cmbEnableCSS);
                        // show error with submission
                        $('#callmeback_confirmation').html('<div id="cmb_error"><span class="callback_title">' + faqApp.obj.translation.cmb_error_header + '</span><i id="close_callmeback" class="fa fa-times"></i><br/><br/><p id="cmb_text">' + faqApp.obj.translation.cmb_error_text + '</p></div>');
                        $(".sp-circle").hide();
                    });
                    // show / hide loading spinner while waiting for ajax response
                    $(document).ajaxComplete(function() {
                        $("#cmb_loading").css("display", "none");
                    });
                }
            });
        });
    });
};

function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return (false);
}

faqApp.func.totop = function() {
    $(document).on('click', '#faq_totop', function() {
        $("html, body").animate({
            scrollTop: 0
        }, "slow");
    });
    $(document).scroll(function() {
        if ($(document).scrollTop() > 201) {
            $('#faq_totop').removeClass('faq_totop_out').addClass('faq_totop_in');
        } else {
            $('#faq_totop').removeClass('faq_totop_in').addClass('faq_totop_out');
        }
    });
};

// hide/unhide callmeback button as soon as it becomes hidden
$(document).scroll(function() {
    if (faqApp.cmb.permit) {
        if ($(document).scrollTop() > $('#faq_header_row').height()) {
            $('#faq_callmeback').removeClass('faq_callmeback_out').addClass('faq_callmeback_in');
        } else {
            $('#faq_callmeback').removeClass('faq_callmeback_in').addClass('faq_callmeback_out');
        }
    }
});

// call me back button to allow customer request a call from CS agent
var cmbEnableCSS = {
    'visibility': 'visible',
    'opacity': '1'
};
var cmbDisableCSS = {
    'visibility': 'hidden',
    'opacity': '0'
};
$(document).on('click', '#faq_callmeback, #faq_info_phone', function() {
    if (faqApp.cmb.permit) { // for CMB enabled brands / languages only
        $('.background_blanket').css(cmbEnableCSS);
        $("#callmeback_disabled").css(cmbEnableCSS).html('<div class="sp sp-circle"></div>').show(); // loading spinner for slow network
        // check if enabled or disabled
        url = '/api.php?bi=' + faqApp.vars.brand + '&action=getCMBswitch';
        faqApp.func.ajax(url, null, false, function(data) {
            if (data.length > 0) {
                faqApp.cmb.on = data[0];
            }
            $("#callmeback_disabled").css(cmbDisableCSS);
            $(".sp-circle").hide(); // hide loading spinner
            if (faqApp.cmb.on == 1) {
                $('#callmeback_div').css(cmbEnableCSS); // open form - make form visible
                // $('#cmb_select').html();
                if ($(window).width() < 992) { // if on mobile device, hide floating buttons
                    $('#faq_totop').css(cmbDisableCSS);
                    $('#faq_callmeback').css(cmbDisableCSS);
                }
            } else {
                var cmb_unavailable_text = faqApp.obj.translation.cmb_unavailable_text.replace(/(\[email\])/g, "<b>" + faqApp.obj.info.info_emailaddress + "</b>");
                $('#callmeback_disabled').html('<span class="callback_title">' + faqApp.obj.translation.cmb_unavailable_header + '</span><i id="close_callmeback" class="fa fa-times"></i><br/><br/><p id="cmb_text">' + cmb_unavailable_text + '</p>');
                $('#callmeback_disabled').css(cmbEnableCSS);
            }
        });
    }
});

//mail form show/hide Functionality
$(document).on('click', '#faq_info_email', function() {
    // Implement if we launch email form
});


$(document).on('click', '#close_callmeback', function(event) {
    // close form - make it invisible
    faqApp.func.closeCMBform();
    faqApp.func.closeBackgroundBlanket();
});

faqApp.func.closeCMBform = function(event) {
    $('#callmeback_div').css(cmbDisableCSS);
    $('#livechat_div').css(cmbDisableCSS);
    $('#mailform_div').css(cmbDisableCSS);
    $('#live-chat-form-div').css(cmbDisableCSS);
    $("#callmeback_confirmation").css(cmbDisableCSS);
    $("#callmeback_disabled").css(cmbDisableCSS);
    // if on mobile device, show floating buttons
    if ($(window).width() < 992) {
        $('#faq_totop').css(cmbEnableCSS);
        $('#faq_callmeback').css(cmbEnableCSS);
    }
};
faqApp.func.closeBackgroundBlanket = function() {
    $('.background_blanket').css(cmbDisableCSS);
};
$(document).on('click', '#close_callmeback, .background_blanket', function(event) {
    // close form - make it invisible
    faqApp.func.closeCMBform();
    faqApp.func.closeBackgroundBlanket();
    $('#cookie_settings').css(cmbDisableCSS);

});

if (getQueryVariable("showCmb") == "true") {
    if (faqApp.cmb.permit == false) { // for CMB enabled brands / languages only
        $('.background_blanket').css(cmbEnableCSS);
        $("#callmeback_disabled").css(cmbEnableCSS).html('<div class="sp sp-circle"></div>').show(); // loading spinner for slow network
        // check if enabled or disabled
        url = '/api.php?bi=' + faqApp.vars.brand + '&action=getCMBswitch';
        faqApp.func.ajax(url, null, false, function(data) {
            if (data.length > 0) {
                faqApp.cmb.on = data[0];
                console.log(data[0]);
            }
            $("#callmeback_disabled").css(cmbDisableCSS);
            $(".sp-circle").hide(); // hide loading spinner
            if (faqApp.cmb.on == 1) {
                $('#callmeback_div').css(cmbEnableCSS); // open form - make form visible
                // $('#cmb_select').html();
                if ($(window).width() < 992) { // if on mobile device, hide floating buttons
                    $('#faq_totop').css(cmbDisableCSS);
                    $('#faq_callmeback').css(cmbDisableCSS);
                }
            }
        });
    }
}

// validate form
$(document).on('click', '#faq_callmeback, #faq_info_phone', function(event) {
    if (faqApp.cmb.permit) { // for CMB enabled brands / languages only
        $(".callmeback_form").validate({
            rules: {
                cmb_name: "required",
                cmb_email: {
                    required: true,
                    email: true,
                    validEmail: true
                },
                cmb_tel: {
                    required: true,
                    validTel: true
                },
                cmb_id: "required",
                cmb_message: "required",
            },
            messages: {
                cmb_name: {
                    required: faqApp.obj.translation.cmb_validation_empty
                },
                cmb_email: {
                    required: faqApp.obj.translation.cmb_validation_empty,
                    email: faqApp.obj.translation.cmb_validation_email,
                    validEmail: faqApp.obj.translation.cmb_validation_email
                },
                cmb_tel: {
                    required: faqApp.obj.translation.cmb_validation_empty,
                    validTel: faqApp.obj.translation.cmb_validation_phone
                },
                cmb_id: {
                    required: faqApp.obj.translation.cmb_validation_empty
                },
                cmb_message: {
                    required: faqApp.obj.translation.cmb_validation_empty
                }
            },
            highlight: function(el) {
                $(el).addClass('invalid-field');
            },
            unhighlight: function(el) {
                $(el).removeClass('invalid-field');
            },
            submitHandler: function(form) {
                console.log("has entered submit function");
                // removes default submit events and establishes AJAX call
                event.preventDefault();
                faqApp.func.closeCMBform();
                var brand = faqApp.vars.brand;
                // show loading bars
                $("#callmeback_confirmation").css(cmbEnableCSS).html('<div class="sp sp-circle"></div>').show();
                var form = $('.callmeback_form');
                var formMessages = $('#callmeback_confirmation');
                // form to json
                var formData = {
                    cmb_name: $('#cmb_name').val(),
                    cmb_email: $('#cmb_email').val(),
                    cmb_tel: $('#cmb_tel').val(),
                    cmb_id: $('#cmb_id').val(),
                    cmb_time: $('input[name=cmb_time]:checked').val(),
                    cmb_message: $('#cmb_message').val(),
                };
                $.ajax({
                    type: 'POST',
                    timeout: 15000,
                    url: faqApp.vars.host + '/cmb.php',
                    global: false,
                    data: {
                        formData: formData,
                        brand: faqApp.vars.brand,
                        lang: faqApp.vars.language
                    }
                }).done(function(response) {
                    // clear fields on successful submission
                    $('.callmeback_form').trigger('reset');
                    // show success submission
                    $('#callmeback_confirmation').html('<div id="cmb_success"><span class="callback_title">' + faqApp.obj.translation.cmb_success_header + '</span><i id="close_callmeback" class="fa fa-times"></i><br/><br/><p id="cmb_text">' + faqApp.obj.translation.cmb_success_text + '</p></div>');
                    $(".sp-circle").hide();
                }).fail(function(data) {
                    // show error with submission
                    $('#callmeback_confirmation').html('<div id="cmb_error"><span class="callback_title">' + faqApp.obj.translation.cmb_error_header + '</span><i id="close_callmeback" class="fa fa-times"></i><br/><br/><p id="cmb_text">' + faqApp.obj.translation.cmb_error_text + '</p></div>');
                    $(".sp-circle").hide();
                });
                // show / hide loading spinner while waiting for ajax response
                $(document).ajaxComplete(function() {
                    $("#cmb_loading").css("display", "none");
                });
            }
        });
    }
});

//mailform Validation
$(document).on('click', '#faq_info_email', function(event) {
    // Implement if we launch email form
});

// if an input field is touched and is invalid, an invalid class is added
$(':required').one('blur keydown', function() {
    $(this).addClass('touched');
});

// removes non-alphanumeric (except '-' and '_') and replaces spaces with '-'
faqApp.func.stringToUrl = function(phrase) {
    phrase = phrase.trim().normalize("NFKD").replace(new RegExp("[^\\p{L}0-9 _\\-/]", "gu"), '');
    phrase = phrase.replace(/[\s+\/]/g, '-').toLowerCase();
    return encodeURIComponent(phrase);
};

// loads popper.js before bootstrap, since bootstrap depends on popper.js
$(document).ready(function() {
    progressLoader(20);
    $.getScript("../assets/scripts/lib/bootstrap.min.js", function(data, textStatus, jqxhr) {}).done(function() {
        progressLoader(20);
        faqApp.func.Initialize(faqApp.obj.Initialize);
    });
});

// Function that handles OneTrust cookie system logic
function oneTrustLogic() {
    // console.log("OneTrustLogic Fired");
    var sentAll;
    var sentFunctional;
    var sentTargeting;
    var sentPerformance;

    var oneTrustPrevious = OnetrustActiveGroups.split(",");

    if(oneTrustPrevious.includes('C0003')){
        sentFunctional = 1;
    }
    else{
        sentFunctional = 0;
    }
    if(oneTrustPrevious.includes('C0004')){
        sentTargeting = 1;
    }
    else{
        sentTargeting = 0;
    }
    if(oneTrustPrevious.includes('C0002')){
        sentPerformance = 1;
    }
    else{
        sentPerformance = 0;
    }
    if(oneTrustPrevious.includes("C0003") && oneTrustPrevious.includes("C0004") && oneTrustPrevious.includes("C0002"))
    {
        sentAll = 1;
        sentFunctional = 1;
        sentTargeting = 1;
        sentPerformance = 1;

    }
    else{
        sentAll = 0;
    }

    OneTrust.OnConsentChanged(function(){
        // console.log("ON CONSENT CHANGE FIRED");
        var oneTrustActive = OnetrustActiveGroups.split(",");
        var consent = {
            marketing: 0,
            targeting: 0,
            performance: 0,
            functional: 0
        };
        var cname = `${encodeURIComponent(JSON.stringify(consent))}`;
        faqApp.func.setCookie('CONSENT', cname, 2, faqApp.vars.secondLevelDomain, '/');

        if(oneTrustActive.includes("C0003")){
            consent.functional = 1;
            var cname = `${encodeURIComponent(JSON.stringify(consent))}`;
            faqApp.func.setCookie('CONSENT', cname, 2, faqApp.vars.secondLevelDomain, '/');
        }
        if(oneTrustActive.includes("C0004")){
            consent.targeting = 1;
            consent.marketing = 1;
            var cname = `${encodeURIComponent(JSON.stringify(consent))}`;
            faqApp.func.setCookie('CONSENT', cname, 2, faqApp.vars.secondLevelDomain, '/');
        }
        if(oneTrustActive.includes("C0002")){
            consent.performance = 1;

            var cname = `${encodeURIComponent(JSON.stringify(consent))}`;
            faqApp.func.setCookie('CONSENT', cname, 2, faqApp.vars.secondLevelDomain, '/');
        }
        if(oneTrustActive.includes("C0005")){
            consent.marketing = 1;
            var cname = `${encodeURIComponent(JSON.stringify(consent))}`;
            faqApp.func.setCookie('CONSENT', cname, 2, faqApp.vars.secondLevelDomain, '/');
        }
        if(oneTrustActive.includes("C0003") && oneTrustActive.includes("C0004") && oneTrustActive.includes("C0002") && sentAll != 1 && sentFunctional != 1 && sentTargeting != 1 && sentPerformance != 1)
        {
            dataLayer.push({
              "event": "GDPRConsent",
              "GDPRTargetingAccepted": consent.targeting.toString(),
              "GDPRPerformanceAccepted": consent.performance.toString(),
              "GDPRFunctionalAccepted": consent.functional.toString(),
              "gdpr_performance_enabled": consent.performance.toString(),
              "gdpr_targeting_enabled": consent.targeting.toString(),
              "gdpr_functional_enabled": consent.functional.toString()
            });
            sentAll = 1;
            sentFunctional = 1;
            sentTargeting = 1;
            sentPerformance = 1;
        }
        else if(oneTrustActive.includes("C0003") && oneTrustActive.includes("C0004") && sentTargeting != 1 && sentFunctional != 1)
        {
            dataLayer.push({
              "event": "GDPRConsent",
              "GDPRTargetingAccepted": consent.targeting.toString(),
              "GDPRFunctionalAccepted": consent.functional.toString(),
              "gdpr_performance_enabled": consent.performance.toString(),
              "gdpr_targeting_enabled": consent.targeting.toString(),
              "gdpr_functional_enabled": consent.functional.toString()
            });
            sentFunctional = 1;
            sentTargeting = 1;
            sentPerformance = 0;
        }
        else if(oneTrustActive.includes("C0003") && oneTrustActive.includes("C0002") && sentPerformance != 1 && sentFunctional != 1)
        {
            dataLayer.push({
              "event": "GDPRConsent",
              "GDPRPerformanceAccepted": consent.performance.toString(),
              "GDPRFunctionalAccepted": consent.functional.toString(),
              "gdpr_performance_enabled": consent.performance.toString(),
              "gdpr_targeting_enabled": consent.targeting.toString(),
              "gdpr_functional_enabled": consent.functional.toString()
            });
            sentFunctional = 1;
            sentPerformance = 1;
            sentTargeting = 0;
        }
        else if(oneTrustActive.includes("C0004") && oneTrustActive.includes("C0002") && sentPerformance != 1 && sentTargeting != 1)
        {
            dataLayer.push({
              "event": "GDPRConsent",
              "GDPRPerformanceAccepted": consent.performance.toString(),
              "GDPRTargetingAccepted": consent.targeting.toString(),
              "gdpr_performance_enabled": consent.performance.toString(),
              "gdpr_targeting_enabled": consent.targeting.toString(),
              "gdpr_functional_enabled": consent.functional.toString()
            });
            sentPerformance= 1;
            sentTargeting = 1;
            sentFunctional = 0;
        }
        else if(oneTrustActive.includes("C0003") && sentFunctional != 1)
        {
            dataLayer.push({
              "event": "GDPRConsent",
              "GDPRFunctionalAccepted": consent.functional.toString(),
              "gdpr_performance_enabled": consent.performance.toString(),
              "gdpr_targeting_enabled": consent.targeting.toString(),
              "gdpr_functional_enabled": consent.functional.toString()
            });
            sentFunctional = 1;
        }
        else if(oneTrustActive.includes("C0004") && sentTargeting != 1)
        {
            dataLayer.push({
              "event": "GDPRConsent",
              "GDPRTargetingAccepted": consent.targeting.toString(),
              "gdpr_performance_enabled": consent.performance.toString(),
              "gdpr_targeting_enabled": consent.targeting.toString(),
              "gdpr_functional_enabled": consent.functional.toString()
            });
            sentTargeting = 1;
        }
        else if(oneTrustActive.includes("C0002") && sentPerformance != 1)
        {
            dataLayer.push({
              "event": "GDPRConsent",
              "GDPRPerformanceAccepted": consent.performance.toString(),
              "gdpr_performance_enabled": consent.performance.toString(),
              "gdpr_targeting_enabled": consent.targeting.toString(),
              "gdpr_functional_enabled": consent.functional.toString()
            });
            sentPerformance = 1;
        }
        else
        {
            dataLayer.push({
              "gdpr_performance_enabled": consent.performance.toString(),
              "gdpr_targeting_enabled": consent.targeting.toString(),
              "gdpr_functional_enabled": consent.functional.toString()
            });
        }
        if(oneTrustActive.includes('C0003')){
            sentFunctional = 1;
        }
        else{
            sentFunctional = 0;
        }
        if(oneTrustActive.includes('C0004')){
            sentTargeting = 1;
        }
        else{
            sentTargeting = 0;
        }
        if(oneTrustActive.includes('C0002')){
            sentPerformance = 1;
        }
        else{
            sentPerformance = 0;
        }
        if((sentFunctional == 1) && (sentTargeting == 1) && (sentPerformance == 1))
        {
            sentAll = 1;
        }
        else{
            sentAll = 0;
        }
    });
}

// GDPR - cookies consent (yes clicked)
faqApp.func.cookiesAcknowledged = function(value) {
    // generate cookie so snackbar doesn't show again
    // 0: marketing tags NOT allowed ('cookie settings' link pressed) - GTM set to FALSE
    // 1: marketing tags allowed ('ACCEPT' button pressed) - GTM set to TRUE
    consent = {
        marketing: value,
        targeting: value,
        performance: value,
        functional: value
    };
    var cname = `${encodeURIComponent(JSON.stringify(consent))}`;
    faqApp.func.setCookie('CONSENT', cname, 2, faqApp.vars.secondLevelDomain, '/');
    if (value == 1) {
        // push marketing consent to GTM
        pushDatalayer(5, null, null, null, null, null, null, null);
        // OneTrust Hybrid
        pushDatalayer(7, null, null, null, null, null, null, null);
    }
    else if (value == 0){
        pushDatalayer(8, null, null, null, null, null, null, null);
    }
    // remove cookie bars & resize view
    $('#cookie-policy').css('display', 'none');
    // push floating buttons back downwards
    $('#faq_totop').css('top', $('#faq_totop').position().top + $('#cookie-policy').outerHeight());
    $('#faq_callmeback').css('top', $('#faq_callmeback').position().top + $('#cookie-policy').outerHeight());
};

// set cookie with name, value, expiry date, domain
faqApp.func.setCookie = function(key, value, expiry, domain, path) {
    var date = new Date();
    date.setTime(date.getTime() + (31536000000 * expiry)); // current time + (365 days * no. of years)
    document.cookie = `${key}=${value};expires=${date.toUTCString()};domain=${domain};path=${path}`;
};

// get value of cookie
faqApp.func.getCookie = function(key) {
    var value = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return value ? value[2] : null;
};

var progressLoader = (function(a) {
    var progress = 10;
    if (progress < 100) {
        return function(a) {
            if ($('#ajaxProgressBar')) {
                $('#ajaxProgressBar').css({
                    width: (progress + a) + '%'
                }).attr('aria-valuenow', (progress + a));
            }
            if ((progress + a) >= 100) {
                $('#ajaxProgress').css({
                    transition: "all 0.5s",
                    opacity: 0,
                });
                setTimeout(function() {
                    $('#ajaxProgress').remove();
                    // document.getElementById('snow-div').style.display = 'block';
                }, 500);
            }
            return progress += a;
        };
    }
})();


// pushing data to dataLayer googletagmanager 5
pushDatalayer = function(sel, categoryId, categoryName, recordId, recordTitle, searchKeyword, numberOfRecords, vote) {
    var recordTitleUrl = "";
    var categoryNameUrl = "";

    if (recordTitle !== null) {
        recordTitleUrl = faqApp.func.stringToUrl(recordTitle);
    }
    if (categoryName !== null) {
        categoryNameUrl = faqApp.func.stringToUrl(categoryName);
    }

    switch (sel) {
        // category click - virtualPageView
        case 0: {
            dataLayer.push({
                "event": "virtualPageView",
                "VirtualTitle": "Help Centre | Category | " + categoryName.trim(),
                "VirtualUrl": "/" + faqApp.vars.language + "/category/" + categoryNameUrl
            });
            break;
        }

        // record click - virtualPageView
        case 1: {
            baseRecordUrl = "/" + faqApp.vars.language;
            if (categoryName == 'Quick Link') {
                baseRecordUrl += '/quicklink';
            }
            // on search page?
            if (faqApp.vars.onSearchPage === true) {
                categoryName = "Search Results";
                baseRecordUrl += "/search-results";
            }

            baseRecordUrl += "/faq/";

            dataLayer.push({
                "event": "virtualPageView",
                "VirtualTitle": "Help Centre | " + recordTitle.trim(),
                "VirtualUrl": baseRecordUrl + recordTitleUrl,
                "Area": "Customer Service",
                "cs_lobby_faq_category": categoryName.trim(),
                "cs_lobby_faq_id": recordId
            });
            break;
        }

        // search click - event
        case 2: {

            var rfc5322RegExp = new RegExp(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi);
            if (rfc5322RegExp.test(searchKeyword)) {
                searchKeyword = searchKeyword.replace(rfc5322RegExp, '[email-address]');
            }

            dataLayer.push({
                "event": "search",
                "cs_lobby_keyword": searchKeyword.trim(),
                "cs_lobby_number_of_results": numberOfRecords,
                "VirtualUrl": "/" + faqApp.vars.language + "/search?w=" + searchKeyword
            });
            break;
        }

        // Vote click - event
        case 3: {
            dataLayer.push({
                "event": "vote",
                "cs_lobby_faq_id": recordId,
                "cs_lobby_faq_name": recordTitle.trim(), // top fix
                "cs_lobby_faq_vote": vote, // yes / no
            });
            break;
        }

        // faq_info button link
        case 4: {
            dataLayer.push({
                "event": "cs_lobby_external_link",
                "cs_lobby_external_link_destination": recordTitle.trim(),
                "VirtualUrl": "/" + faqApp.vars.language + "/" + recordTitleUrl
            });
            break;
        }
        // fired when marketing consent is set
        case 5: {
            dataLayer.push({
                "event": "MarketingConsent"
            });
            break;
        }
        // Testing main page tracking
        case 6:
          dataLayer.push({
            "event": "virtualPageView",
            "VirtualTitle": "Help Centre",
            "VirtualUrl": "/" + faqApp.vars.language
          });
          break;
          // Testing OneTrust - When user ACCEPTS all cookies
          case 7:
            dataLayer.push({
              "event": "GDPRConsent",
              "GDPRTargetingAccepted": "1",
              "GDPRPerformanceAccepted": "1",
              "GDPRFunctionalAccepted": "1",
              "gdpr_performance_enabled": "1",
              "gdpr_targeting_enabled": "1",
              "gdpr_functional_enabled": "1"
            });
            break;
            // Testing OneTrust - When user DECLINES all cookies
            case 8:
              dataLayer.push({
                "event": "GDPRConsent",
                "GDPRTargetingAccepted": "0",
                "GDPRPerformanceAccepted": "0",
                "GDPRFunctionalAccepted": "0",
                "gdpr_performance_enabled": "0",
                "gdpr_targeting_enabled": "0",
                "gdpr_functional_enabled": "0"
              });
              break;
    }
};
